// Copyright © 2026 SHIELD Intelligence. All rights reserved.
import React from "react";
import AccountItem from "./AccountItem";

function AccountList({ accounts, codes, countdowns, handleCopy, maskCodes, showProviderLogos, setEditing, setForm, setShowDelete, showDelete, handleDelete, openConfirm, searchQuery, totalAccounts, loadingAccounts }) {
  // Show loading state while fetching accounts
  if (loadingAccounts) {
    return (
      <div className="accountList">
        <div className="loading-accounts">
          <div className="shield-spinner"></div>
          <p>Loading accounts...</p>
        </div>
      </div>
    );
  }

  // Empty states
  if (accounts.length === 0) {
    const hasAnyAccounts = Number(totalAccounts) > 0;
    const q = String(searchQuery || "").trim();
    return (
      <div className="accountList">
        <div className="no-results">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="currentColor" opacity="0.3">
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          </svg>
          <h3>No accounts yet</h3>
          {!hasAnyAccounts ? (
            <p>Add an account to get started.</p>
          ) : q ? (
            <p>No accounts match "{q}"</p>
          ) : (
            <p>No accounts match your search.</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="accountList">
      {accounts.map((acc) => (
        <AccountItem
          key={acc.id}
          acc={acc}
          codes={codes}
          countdowns={countdowns}
          handleCopy={handleCopy}
          maskCodes={maskCodes}
          showProviderLogos={showProviderLogos}
          setEditing={setEditing}
          setForm={setForm}
          setShowDelete={setShowDelete}
          showDelete={showDelete}
          handleDelete={handleDelete}
          openConfirm={openConfirm}
        />
      ))}
    </div>
  );
}

export default AccountList;
